module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nif(formMapping.modelFieldIndex >= 0 && model.fields && model.fields[formMapping.modelFieldIndex] && model.fields[formMapping.modelFieldIndex].atom){\nif(model.fields[formMapping.modelFieldIndex].atom.renderType && model.fields[formMapping.modelFieldIndex].atom.renderType != 'none'){\nvar fieldConfig = model.fields[formMapping.modelFieldIndex].config || {};\nvar formBasePath = '../';\nvar fieldPath = '';\nvar hidden = false;\nvar disabled = false;\nvar isFilterField = false;\nvar preventFieldLabel = Boolean(config.preventAllFieldLabels);\nvar additionalClasses = '';\nif(formMapping.fieldConfig){\nif(formMapping.fieldConfig.hidden || fieldConfig.hidden){\nhidden = true;\n}\nif(formMapping.fieldConfig.disabled || fieldConfig.disabled){\ndisabled = true;\n}\nif(formMapping.fieldConfig.isFilterField){\nisFilterField = true;\n}\nif(formMapping.fieldConfig.preventFieldLabel || fieldConfig.preventFieldLabel){\npreventFieldLabel = true;\n}\nif(formMapping.fieldConfig.additionalClasses || fieldConfig.additionalClasses){\nadditionalClasses = formMapping.fieldConfig.additionalClasses;\n}\nif(formMapping.fieldConfig.fieldPath){\nfieldPath = '../../../' + formMapping.fieldConfig.fieldPath.replace(/^\\//, '').replace(/\\/$/, '');\n}\n}\nif(fieldConfig.formBasePath){\nformBasePath = '../../../' + String(fieldConfig.formBasePath).replace(/^\\//, '').replace(/\\/$/, '') + '/';\n}\nif(!fieldPath){\nif(fieldConfig.fieldPath){\nfieldPath = '../../../' + fieldConfig.fieldPath.replace(/^\\//, '').replace(/\\/$/, '');\n} else if(model.fields[formMapping.modelFieldIndex].atom.renderType !== 'custom') {\nfieldPath = formBasePath + 'fields/' + model.fields[formMapping.modelFieldIndex].atom.renderType;\n}\n}\npreventFieldLabel = preventFieldLabel || isFilterField || fieldConfig.preventFieldLabel;\nmodel.fields[formMapping.modelFieldIndex].label = '';\nmodel.fields[formMapping.modelFieldIndex].description = '';\nmodel.fields[formMapping.modelFieldIndex].information = '';\nmodel.fields[formMapping.modelFieldIndex].placeholder = '';\nif(model.fields[formMapping.modelFieldIndex].lang && storage && storage.user && storage.user.data && storage.user.data.langCode && model.fields[formMapping.modelFieldIndex].lang[storage.user.data.langCode]){\nvar currentLangData = model.fields[formMapping.modelFieldIndex].lang[storage.user.data.langCode];\nif(currentLangData.label){\nmodel.fields[formMapping.modelFieldIndex].label = currentLangData.label;\nmodel.fields[formMapping.modelFieldIndex].placeholder = currentLangData.label;\n}\nif(currentLangData.description){\nmodel.fields[formMapping.modelFieldIndex].description = currentLangData.description;\n}\nif(currentLangData.information){\nmodel.fields[formMapping.modelFieldIndex].information = currentLangData.information;\n}\n}\nif(formMapping.labelKey){\nmodel.fields[formMapping.modelFieldIndex].label = __(formMapping.labelKey);\nmodel.fields[formMapping.modelFieldIndex].placeholder = model.fields[formMapping.modelFieldIndex].label;\n}\nif(isFilterField){\nmodel.fields[formMapping.modelFieldIndex].placeholder = __('filter') + ' ' + model.fields[formMapping.modelFieldIndex].placeholder;\n}\n%>\n<div class=\"field<%= (disabled ? ' disabled' : '') %><%= (hidden ? ' hidden' : '') %><%= (additionalClasses ? ' ' + additionalClasses : '') %> fieldOf_<%- model.fields[formMapping.modelFieldIndex].fieldCode %>\">\n<%\nif(fieldPath && !hidden){\nif(!preventFieldLabel){\n%><%- include('label', { formMapping: formMapping, model: model.fields[formMapping.modelFieldIndex] }); %><%\n}\n%><%- include(fieldPath, { formMapping: formMapping, model: model.fields[formMapping.modelFieldIndex], config: (model.fields[formMapping.modelFieldIndex].config || {}).componentConfig || {} }); %><%\n} else {\n%><span class=\"hidden-<%- model.fields[formMapping.modelFieldIndex].fieldCode %>\"></span><%\n}\n%>\n</div>\n<%\n}\nelse {\n%>\n<span class=\"hidden-<%- model.fields[formMapping.modelFieldIndex].fieldCode %>\"></span>\n<%\n}\n}\n%>"
  , __filename = "node_modules/frontend-controller/baseComponents/form/elements/field.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
if(formMapping.modelFieldIndex >= 0 && model.fields && model.fields[formMapping.modelFieldIndex] && model.fields[formMapping.modelFieldIndex].atom){
if(model.fields[formMapping.modelFieldIndex].atom.renderType && model.fields[formMapping.modelFieldIndex].atom.renderType != 'none'){
var fieldConfig = model.fields[formMapping.modelFieldIndex].config || {};
var formBasePath = '../';
var fieldPath = '';
var hidden = false;
var disabled = false;
var isFilterField = false;
var preventFieldLabel = Boolean(config.preventAllFieldLabels);
var additionalClasses = '';
if(formMapping.fieldConfig){
if(formMapping.fieldConfig.hidden || fieldConfig.hidden){
hidden = true;
}
if(formMapping.fieldConfig.disabled || fieldConfig.disabled){
disabled = true;
}
if(formMapping.fieldConfig.isFilterField){
isFilterField = true;
}
if(formMapping.fieldConfig.preventFieldLabel || fieldConfig.preventFieldLabel){
preventFieldLabel = true;
}
if(formMapping.fieldConfig.additionalClasses || fieldConfig.additionalClasses){
additionalClasses = formMapping.fieldConfig.additionalClasses;
}
if(formMapping.fieldConfig.fieldPath){
fieldPath = '../../../' + formMapping.fieldConfig.fieldPath.replace(/^\//, '').replace(/\/$/, '');
}
}
if(fieldConfig.formBasePath){
formBasePath = '../../../' + String(fieldConfig.formBasePath).replace(/^\//, '').replace(/\/$/, '') + '/';
}
if(!fieldPath){
if(fieldConfig.fieldPath){
fieldPath = '../../../' + fieldConfig.fieldPath.replace(/^\//, '').replace(/\/$/, '');
} else if(model.fields[formMapping.modelFieldIndex].atom.renderType !== 'custom') {
fieldPath = formBasePath + 'fields/' + model.fields[formMapping.modelFieldIndex].atom.renderType;
}
}
preventFieldLabel = preventFieldLabel || isFilterField || fieldConfig.preventFieldLabel;
model.fields[formMapping.modelFieldIndex].label = '';
model.fields[formMapping.modelFieldIndex].description = '';
model.fields[formMapping.modelFieldIndex].information = '';
model.fields[formMapping.modelFieldIndex].placeholder = '';
if(model.fields[formMapping.modelFieldIndex].lang && storage && storage.user && storage.user.data && storage.user.data.langCode && model.fields[formMapping.modelFieldIndex].lang[storage.user.data.langCode]){
var currentLangData = model.fields[formMapping.modelFieldIndex].lang[storage.user.data.langCode];
if(currentLangData.label){
model.fields[formMapping.modelFieldIndex].label = currentLangData.label;
model.fields[formMapping.modelFieldIndex].placeholder = currentLangData.label;
}
if(currentLangData.description){
model.fields[formMapping.modelFieldIndex].description = currentLangData.description;
}
if(currentLangData.information){
model.fields[formMapping.modelFieldIndex].information = currentLangData.information;
}
}
if(formMapping.labelKey){
model.fields[formMapping.modelFieldIndex].label = __(formMapping.labelKey);
model.fields[formMapping.modelFieldIndex].placeholder = model.fields[formMapping.modelFieldIndex].label;
}
if(isFilterField){
model.fields[formMapping.modelFieldIndex].placeholder = __('filter') + ' ' + model.fields[formMapping.modelFieldIndex].placeholder;
}

    ; __line = 67
    ; __append("\n<div class=\"field")
    ; __line = 68
    ; __append(escapeFn( (disabled ? ' disabled' : '') ))
    ; __append(escapeFn( (hidden ? ' hidden' : '') ))
    ; __append(escapeFn( (additionalClasses ? ' ' + additionalClasses : '') ))
    ; __append(" fieldOf_")
    ; __append( model.fields[formMapping.modelFieldIndex].fieldCode )
    ; __append("\">\n")
    ; __line = 69
    ; 
if(fieldPath && !hidden){
if(!preventFieldLabel){

    ; __line = 72
    ; __append( include('label', { formMapping: formMapping, model: model.fields[formMapping.modelFieldIndex] }) )
    ; 
}

    ; __line = 74
    ; __append( include(fieldPath, { formMapping: formMapping, model: model.fields[formMapping.modelFieldIndex], config: (model.fields[formMapping.modelFieldIndex].config || {}).componentConfig || {} }) )
    ; 
} else {

    ; __line = 76
    ; __append("<span class=\"hidden-")
    ; __append( model.fields[formMapping.modelFieldIndex].fieldCode )
    ; __append("\"></span>")
    ; 
}

    ; __line = 78
    ; __append("\n</div>\n")
    ; __line = 80
    ; 
}
else {

    ; __line = 83
    ; __append("\n<span class=\"hidden-")
    ; __line = 84
    ; __append( model.fields[formMapping.modelFieldIndex].fieldCode )
    ; __append("\"></span>\n")
    ; __line = 85
    ; 
}
}

    ; __line = 88
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=node_modules/frontend-controller/baseComponents/form/elements/field.ejs

}